<template>
  <div class="target-edit-form-container">
    <app-filter :filter-list="table_filter" default-label-width="100px" @search="search" />
    <div class="text-right">
      <el-button v-if="isSupportPull()" size="mini" type="success" @click="onPull">同步</el-button>
      <el-button :loading="add_btn_loading" size="mini" type="primary" @click="onAdd">新增定向</el-button>
    </div>
    <app-table
      ref="app_table_ref"
      class="mt-20"
      :table-key="table_key"
      :tablep="table_params"
      :get-data="getTargetingList"
      :table-props="{
        'max-height': '450px'
      }"
      :check="true"
      check-key="id"
      :is-reserve-checked="true"
      :is-row-click="true"
      @select-tr="selectionChange"
      @hook:mounted="onTableMounted"
    />
    <!-- 新增/详情弹窗 -->
    <el-dialog
      :title="dialog_config.title"
      :visible.sync="dialog_config.is_show"
      :close-on-click-modal="false"
      :append-to-body="true"
      :modal-append-to-body="true"
      :width="dialog_config.width"
    >
      <app-form
        v-if="dialog_config.is_show"
        ref="app_form_ref"
        scrollbar-wrap-style="max-height: 550px;"
        :form-data="dialog_config.form_config"
        default-label-width="130px"
        :is-show-button="dialog_config.is_show_button"
        @confirm="dialog_config.confirm"
        @cancel="dialog_config.is_show = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import { CHANNEL_INTERFACE_TYPE } from '@/enums';
import { clone } from '@/utils';
import { formDataAssign, transformFormToPreview } from '@/tools/form';
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';
import {
  getTargetingListApi,
  pullTargetingListApi,
  addTargetingDataApi,
  getTargetingDataApi,
  deleteTargetingDataApi,
  editTargetingDataApi,
} from '@/api/tool/targeting';

export default {
  components: {
    'app-filter': () => import('@/components/app-filter'),
    'app-table': () => import('@/components/app-table'),
    'app-form': () => import('@/components/app-form'),
  },
  mixins: [data_sharing_mixin],
  props: {
    // 模块表单配置
    formFields: {
      type: Object,
      required: true,
    },
    /** 广告主ID */
    advertiserId: {
      type: [Number, String],
      required: true,
    },
    /** 分配的定向包数据 */
    assignSelection: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      /** 过滤项配置 */
      table_filter: require('./model/table-filter.js')(this),
      /** 表头配置 */
      table_key: require('./model/table-key.js')(this),
      /** 表格请求参数 */
      table_params: {
        page: 1,
        limit: 10,
      },
      /** 弹窗配置 */
      dialog_config: {
        id: '',
        is_show: false,
        title: '新增',
        width: '800px',
        form_config: {},
        is_show_button: true,
        confirm: () => {},
      },
      /** 表单配置 - 整体配置 */
      form_fields: null,
      /** 新增定向按钮loading - 等待接口获取表单选项 */
      add_btn_loading: false,
    };
  },
  async created() {
    try {
      this.add_btn_loading = true;
      this.form_fields = await this.getFormFields();
    } catch (error) {
      console.log(error);
    } finally {
      this.add_btn_loading = false;
    }
  },
  methods: {
    /**
     * 搜索
     * @param {Object} params 过滤参数
     * @returns {void}
     */
    search(params) {
      Object.assign(this.table_params, params);
      this.$refs['app_table_ref'].seekTable();
    },
    /**
     * 新增定向
     * @returns {void}
     */
    onAdd() {
      const form_config = this.getFormConfig();
      Object.assign(this.dialog_config, {
        is_show: true,
        width: '800px',
        title: '新增',
        form_config,
        is_show_button: true,
        confirm: (params) => {
          this.$refs['app_form_ref'].isLoading = true;
          const payload = this.local_sharing_data.getFormContext().strategy.getCreateTargetParams(params, this.dialog_config.form_config);
          const { channel_interface } = this.getInitConfig();
          const base_params = {
            channel_interface,
            advertiser_id: this.advertiserId,
          };
          this.addTargetingData({ ...base_params, ...payload }).then(res => {
            this.$message.success(res?.message || '新增成功');
            this.dialog_config.is_show = false;
            this.$refs['app_table_ref'].seekTable();
          }).finally(() => (this.$refs?.['app_form_ref']?.isLoading && (this.$refs['app_form_ref'].isLoading = false)));
        },
      });
    },
    /**
     * 查看详情
     * @param {Object} row 表格行数据
     * @returns {void}
     */
    async onDetail(row) {
      try {
        row.detail_btn_loading = true;
        const result = await this.getTargetingData(row.id);
        const { getTargetPreviewAssociatedMap } = this.local_sharing_data.getFormContext().strategy;
        const form_data = this.local_sharing_data.getFormContext().strategy.getTargetDetailFormData(result);
        const form_config = this.getFormConfig();
        formDataAssign(form_config, form_data, { is_init_backup_value: true });
        await this.dispatchExecListeners(form_config);
        transformFormToPreview({ form_config, associated_map: {
          geo_type: {
            unlimit_key: 'INFINITE',
            associated_keys: ['residence_geo_locations', 'current_geo_locations'],
          },
          audience_types: {
            type: 'options',
            unlimit_key: 'INFINITE',
            associated_keys: ['include_audiences', 'exclude_audiences'],
            associated_options_map: {
              include_audiences: 'INCLUDE',
              exclude_audiences: 'EXCLUDE',
            },
          },
          ...getTargetPreviewAssociatedMap(),
        }});
        Object.assign(this.dialog_config, {
          is_show: true,
          width: '500px',
          title: '详情',
          form_config,
          is_show_button: false,
          confirm: () => {},
        });
      } catch (error) {
        console.log(error);
      } finally {
        row.detail_btn_loading = false;
      }
    },
    /**
     * 删除定向
     * @param {Object} row 表格行数据
     * @returns {Promise<void>}
     */
    async onDeleteTargeting(row) {
      this.$confirm('是否删除当前已选中的定向包？', row.name, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        row.delete_btn_loading = true;
        this.deleteTargetingData(row.id).then(({ message }) => {
          this.$message.success(message || '删除成功');
          this.$refs['app_table_ref'].seekTable();
        }).finally(() => {
          row.delete_btn_loading = false;
        });
      });
    },
    /**
     * 编辑定向
     * @param {Object} row 表格行数据
     * @returns {Promise<void>}
     */
    async onEditTargeting(row) {
      try {
        row.edit_btn_loading = true;
        const result = await this.getTargetingData(row.id);
        const form_data = this.local_sharing_data.getFormContext().strategy.getTargetDetailFormData(result);
        const form_config = this.getFormConfig();
        formDataAssign(form_config, form_data, { is_init_backup_value: true });
        await this.dispatchExecListeners(form_config);
        Object.assign(this.dialog_config, {
          is_show: true,
          width: '800px',
          title: '编辑',
          form_config,
          is_show_button: true,
          confirm: (params) => {
            this.$refs['app_form_ref'].isLoading = true;
            const payload = this.local_sharing_data.getFormContext().strategy.getCreateTargetParams(params, this.dialog_config.form_config);
            const { channel_interface } = this.getInitConfig();
            const base_params = {
              channel_interface,
              advertiser_id: this.advertiserId,
            };
            this.editTargetingData(row.id, { ...base_params, ...payload }).then(res => {
              this.$message.success(res?.message || '编辑成功');
              this.dialog_config.is_show = false;
              this.$refs['app_table_ref'].seekTable();
            }).finally(() => (this.$refs?.['app_form_ref']?.isLoading && (this.$refs['app_form_ref'].isLoading = false)));
          },
        });
      } finally {
        row.edit_btn_loading = false;
      }
    },
    /**
     * 获取定向包列表
     * @param {Object} params 接口参数
     * @returns {Promise<Object>}
     */
    getTargetingList(params) {
      const { name, ...rest } = params;
      const { channel_interface } = this.getInitConfig();
      return new Promise((resolve, reject) => {
        getTargetingListApi({
          channel_interface,
          advertiser_id: this.advertiserId,
          ...(name && { filtering: { name }}),
          ...rest,
        }).then(res => {
          res.list = (res?.list || []).map(item => Object.assign(item, {
            detail_btn_loading: false,
            edit_btn_loading: false,
            delete_btn_loading: false,
            advertiser_id: this.advertiserId,
          }));
          resolve({ ...res });
        }).catch(reject);
      });
    },
    /**
     * 是否支持同步
     * @returns {boolean}
     */
    isSupportPull() {
      const support_channels = [CHANNEL_INTERFACE_TYPE.HUAWEI, CHANNEL_INTERFACE_TYPE.OPPO];
      const { channel_interface } = this.getInitConfig();
      return support_channels.includes(channel_interface);
    },
    /**
     * 同步定向包列表
     * @returns {void}
     */
    onPull() {
      const { channel_interface } = this.getInitConfig();
      pullTargetingListApi({ channel_interface, advertiser_id: this.advertiserId }).then(res => {
        this.$message.success(res.message || '同步成功');
        this.$refs['app_table_ref'].seekTable();
      });
    },
    /**
     * 创建定向包
     * @param {Object} params 接口参数
     */
    addTargetingData(params) {
      return new Promise((resolve, reject) => {
        addTargetingDataApi(params).then(resolve).catch(reject);
      });
    },
    /**
     * 编辑定向包
     * @param {string|number} targeting_id 定向包id
     * @param {Object} data body数据
     * @returns {Promise<Object>}
     */
    editTargetingData(targeting_id, data) {
      return new Promise((resolve, reject) => {
        editTargetingDataApi(targeting_id, data).then(resolve).catch(reject);
      });
    },
    /**
     * 获取定向包详情数据
     * @param {number} id 定向包ID
     */
    getTargetingData(id) {
      const { channel_interface } = this.getInitConfig();
      return new Promise((resolve, reject) => {
        getTargetingDataApi(id, { channel_interface, advertiser_id: this.advertiserId }).then(resolve).catch(reject);
      });
    },
    /**
     * 删除定向
     * @param {number} id 定向包ID
     * @returns {Promise<Object>}
     */
    deleteTargetingData(id) {
      const { channel_interface } = this.getInitConfig();
      return new Promise((resolve, reject) => {
        deleteTargetingDataApi(id, { channel_interface, advertiser_id: this.advertiserId }).then(resolve).catch(reject);
      });
    },
    /**
     * 表格选择事件
     * @param {object} rows 表格数据
     */
    selectionChange(rows) {
      this.assignSelection.splice(0);
      this.assignSelection.push(...rows);
    },
    /** 获取初始化配置 */
    getInitConfig() {
      try {
        const { getFormContext } = this.local_sharing_data;
        const form_context = getFormContext();
        const { init_ops } = form_context.config;
        return init_ops || {};
      } catch (error){
        console.error(error);
        return {};
      }
    },
    /**
     * 添加监听事件
     * @param {Object} config 表单配置
     * @param {Object} controller 控制器
     */
    addEvent(config, controller) {
      this.local_sharing_data.getFormContext().strategy.addEvent(config, controller);
    },
    /** 获取初始表单配置 */
    async getFormFields() {
      const { config, strategy } = this.local_sharing_data.getFormContext();
      const form_fields = this.local_sharing_data.getFormContext().strategy.getFields();
      await strategy.setTargetingDataSources(form_fields, config.dataController, this.local_sharing_data.getFormFields());
      return form_fields;
    },
    /** 获取定向表单配置 */
    getFormConfig() {
      const form_fields = clone(this.form_fields);
      const { dataController: controller } = this.local_sharing_data.getFormContext().config;
      this.addEvent(form_fields, controller);
      const { targeting_config } = form_fields;
      const { targeting_form: { config }} = targeting_config.config;
      return config;
    },
    /**
     * 获取change方法监听器
     * @param {Object} config 表单配置
     */
    getChangeEventListeners(config) {
      let change_list = [];
      for (const config_key in config) {
        const item = config[config_key];
        if (config[config_key].children) {
          const config_list = this.getChangeEventListeners(item.children);
          change_list = [
            ...change_list,
            ...config_list,
          ];
        } else if (item.on?.change){
          change_list.push(item.on.change);
        }
      }
      return change_list;
    },
    /**
     * 执行change方法列表
     * @param {Object} form_config 表单配置
     */
    async dispatchExecListeners(form_config){
      let event_list = [];
      if (form_config) {
        const change_list = this.getChangeEventListeners(form_config);
        if (change_list.length){
          event_list = [
            ...event_list,
            ...change_list,
          ];
        }
      }
      try {
        for (let i = 0; i < event_list.length; i++) {
          await event_list[i]();
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    /**
     * 获取分配表单已选项
     * @returns {Promise<Object[]>}
     */
    async getAssignSelection() {
      return Promise.resolve(this.assignSelection);
    },
    /**
     * 初始化表格选中数据
     * @returns {void}
     */
    initRowsSelection() {
      const list = this.formFields.selection_config.list.filter((item) => String(item.advertiser_id) === String(this.advertiserId));
      const app_table_ref = this.$refs.app_table_ref;
      this.assignSelection.splice(0);
      this.assignSelection.push(...list);
      app_table_ref.multipleSelection.splice(0);
      app_table_ref.multipleSelection.push(...this.assignSelection);
      app_table_ref.multipleSelectionAll.splice(0);
      app_table_ref.multipleSelectionAll.push(...this.assignSelection);
    },
    /**
     * 监听表格挂载完成
     * @returns {void}
     */
    onTableMounted() {
      this.initRowsSelection();
    },
  },
};
</script>
